<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const { setLocaleMessage } = useI18n();
// useHead({
//   script: [
//     {
//       innerHTML: `
//         (function(d, s, id) {
//           var js, fjs = d.getElementsByTagName(s)[0];
//           if (d.getElementById(id)) return;
//           js = d.createElement(s); js.id = id;
//           js.src = "https://plugin-code.salesmartly.com/js/project_328009_336903_1746865691.js";
//           fjs.parentNode.insertBefore(js, fjs);
//         }(document, 'script', 'salesmartly-js'));
//       `
//     }
//   ]
// })


useHead({
  script: [
    // {
    //   innerHTML: `
    //       window.Tawk_API = window.Tawk_API || {};
    //       window.Tawk_LoadStart = new Date();
    //       (function() {
    //         var s1 = document.createElement("script");
    //         var s0 = document.getElementsByTagName("script")[0];
    //         s1.async = true;
    //         s1.src = 'https://embed.tawk.to/683eb917678f5e19096efa89/1isqg61dn';
    //         s1.charset = 'UTF-8';
    //         s1.setAttribute('crossorigin', '*');
    //         s0.parentNode.insertBefore(s1, s0);
    //       })();
    //     `,
    // },
    {
      async: true,
      src: "https://www.googletagmanager.com/gtag/js?id=AW-17117943936",
    },
    {
      innerHTML: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-17117943936');
        `,
    },
    {
      innerHTML: `
        const observer = new MutationObserver(function(mutations) {
          if (location.href.includes("submitInfo=true")) {
          gtag('event', 'conversion', {'send_to': 'AW-17117943936/5ok6CM_C0NIaEICxvOI_'});
            observer.disconnect();
          }
        });
        const config = {subtree: true, childList: true};
        observer.observe(document, config);
      `,
    },
  ],
});

// 获取所有文案
const { data: textI18n } = await useFetch<any>('/sre/i18n/alltext/public', {
  baseURL: useRuntimeConfig().public.apiUrl
})
/**
 * 将API返回的i18n数据转换为按语言分组的格式
 * @param {Object} data - 原始API返回的数据
 * @return {Object} - 按语言分组的i18n数据
 */
function transformI18nData(data: any) {
  if (!data || !data.success || !Array.isArray(data.data)) {
    return {}
  }

  const result: any = {}

  // 遍历所有数据项
  data.data.forEach((item: any) => {
    const { key, value } = item

    // 遍历每个语言版本
    Object.entries(value).forEach(([lang, text]) => {
      // 如果该语言的对象不存在，则创建一个
      if (!result[lang]) {
        result[lang] = {}
      }

      // 将当前key和对应的文本添加到该语言对象中
      result[lang][key] = text
    })
  })

  return result
}

// 转换数据格式
const transformedI18n = computed(() => transformI18nData(textI18n.value))

// 提供给全局使用
provide('i18nTexts', transformedI18n)
for (const key in transformedI18n.value) {
  setLocaleMessage(key, transformedI18n.value[key]);
}
</script>

<style>
h2 {
  font-size: 40px !important;
  font-weight: bold !important;
}

h3 {
  font-size: 28px !important;
  font-weight: bold !important;
}

h5 {
  font-size: 24px !important;
}

:root {
  --primary-50: 240 253 244;
  --primary-100: 220 252 231;
  --primary-200: 187 247 208;
  --primary-300: 134 239 172;
  --primary-400: 74 222 128;
  --primary-500: 65 203 90;
  --primary-600: 22 163 74;
  --primary-700: 21 128 61;
  --primary-800: 22 101 52;
  --primary-900: 20 83 45;
  --primary-950: 5 46 22;

  /* Element Plus 主题色变量 */
  --el-color-primary: #41cb5a !important;
  --el-color-primary-light-3: #6cd97f !important;
  --el-color-primary-light-5: #97e6a4 !important;
  --el-color-primary-light-7: #c2f2c9 !important;
  --el-color-primary-light-8: #d5f7da !important;
  --el-color-primary-light-9: #e9fbec !important;
  --el-color-primary-dark-2: #34a248 !important;
}

.dark {
  --primary-50: 5 46 22;
  --primary-100: 20 83 45;
  --primary-200: 22 101 52;
  --primary-300: 21 128 61;
  --primary-400: 22 163 74;
  --primary-500: 65 203 90;
  --primary-600: 74 222 128;
  --primary-700: 134 239 172;
  --primary-800: 187 247 208;
  --primary-900: 220 252 231;
  --primary-950: 240 253 244;

  /* Element Plus 暗色模式主题色变量 */
  --el-color-primary: #41cb5a !important;
  --el-color-primary-light-3: #34a248 !important;
  --el-color-primary-light-5: #2a8a3c !important;
  --el-color-primary-light-7: #1f6d2e !important;
  --el-color-primary-light-8: #174f22 !important;
  --el-color-primary-light-9: #0f3216 !important;
  --el-color-primary-dark-2: #6cd97f !important;
}

.text-primary-50 {
  color: rgb(var(--primary-50) / 1);
}

.text-primary-100 {
  color: rgb(var(--primary-100) / 1);
}

.text-primary-200 {
  color: rgb(var(--primary-200) / 1);
}

.text-primary-300 {
  color: rgb(var(--primary-300) / 1);
}

.text-primary-400 {
  color: rgb(var(--primary-400) / 1);
}

.text-primary-500 {
  color: rgb(var(--primary-500) / 1);
}

.text-primary-600 {
  color: rgb(var(--primary-600) / 1);
}

.text-primary-700 {
  color: rgb(var(--primary-700) / 1);
}

.text-primary-800 {
  color: rgb(var(--primary-800) / 1);
}

.text-primary-900 {
  color: rgb(var(--primary-900) / 1);
}

.text-primary-950 {
  color: rgb(var(--primary-950) / 1);
}

.bg-primary-50 {
  background-color: rgb(var(--primary-50) / 1);
}

.bg-primary-100 {
  background-color: rgb(var(--primary-100) / 1);
}

.bg-primary-200 {
  background-color: rgb(var(--primary-200) / 1);
}

.bg-primary-300 {
  background-color: rgb(var(--primary-300) / 1);
}

.bg-primary-400 {
  background-color: rgb(var(--primary-400) / 1);
}

.bg-primary-500 {
  background-color: rgb(var(--primary-500) / 1);
}

.bg-primary-600 {
  background-color: rgb(var(--primary-600) / 1);
}

.bg-primary-700 {
  background-color: rgb(var(--primary-700) / 1);
}

.bg-primary-800 {
  background-color: rgb(var(--primary-800) / 1);
}

.bg-primary-900 {
  background-color: rgb(var(--primary-900) / 1);
}

.bg-primary-950 {
  background-color: rgb(var(--primary-950) / 1);
}

.border-primary-50 {
  border-color: rgb(var(--primary-50) / 1);
}

.border-primary-100 {
  border-color: rgb(var(--primary-100) / 1);
}

.border-primary-200 {
  border-color: rgb(var(--primary-200) / 1);
}

.border-primary-300 {
  border-color: rgb(var(--primary-300) / 1);
}

.border-primary-400 {
  border-color: rgb(var(--primary-400) / 1);
}

.border-primary-500 {
  border-color: rgb(var(--primary-500) / 1);
}

.border-primary-600 {
  border-color: rgb(var(--primary-600) / 1);
}

.border-primary-700 {
  border-color: rgb(var(--primary-700) / 1);
}

.border-primary-800 {
  border-color: rgb(var(--primary-800) / 1);
}

.border-primary-900 {
  border-color: rgb(var(--primary-900) / 1);
}

.border-primary-950 {
  border-color: rgb(var(--primary-950) / 1);
}

.ring-primary-50 {
  --tw-ring-color: rgb(var(--primary-50) / 1);
}

.ring-primary-100 {
  --tw-ring-color: rgb(var(--primary-100) / 1);
}

.ring-primary-200 {
  --tw-ring-color: rgb(var(--primary-200) / 1);
}

.ring-primary-300 {
  --tw-ring-color: rgb(var(--primary-300) / 1);
}

.ring-primary-400 {
  --tw-ring-color: rgb(var(--primary-400) / 1);
}

.ring-primary-500 {
  --tw-ring-color: rgb(var(--primary-500) / 1);
}

.ring-primary-600 {
  --tw-ring-color: rgb(var(--primary-600) / 1);
}

.ring-primary-700 {
  --tw-ring-color: rgb(var(--primary-700) / 1);
}

.ring-primary-800 {
  --tw-ring-color: rgb(var(--primary-800) / 1);
}

.ring-primary-900 {
  --tw-ring-color: rgb(var(--primary-900) / 1);
}

.ring-primary-950 {
  --tw-ring-color: rgb(var(--primary-950) / 1);
}
</style>
